import { intersection } from 'lodash';

let permissionsService = function (api) {
    const permission = {};
    permission.user = undefined;

    permission.retrievePermissions = () => {
        return new Promise((resolve, reject) => {
            if (!permission.user) {
                return api.get('/api/users/permissions')
                    .then(response => {
                        if (response) {
                            permission.user = response.data;
                            resolve();
                        } else {
                            reject(401);
                        }
                    });
            }
            resolve();
        });
    };

    permission.hasPermission = state => {
        return (!state || !state.roles || (!state.roles.length) || (!!state.roles && permission.user && (intersection(state.roles, permission.user).length || permission.user.indexOf('admin') > -1)));
    };

    return permission;
};

permissionsService.$inject = ['api'];

export default permissionsService;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/auth/services/permissions.service.js